var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentReceived(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "97px",
    height: "92px",
    viewBox: "0 0 97 92",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F23CD2D5-13C7-4099-BE7F-675BD17978CC@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-40.4%",
    y: "-43.1%",
    width: "180.7%",
    height: "186.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 6,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "136.985567%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8E1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE082",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3862C5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3359BA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.4019571,56.5669508 C39.6877889,56.5669508 41.5765466,55.9545035 42.617751,55.2001137 L67.1995797,37.4432423 L67.1995797,13.2003764 C67.1995797,10.5507836 65.0492025,8.40040638 62.3996097,8.40040638 L14.3999099,8.40040638 C11.7503171,8.40040638 9.59993995,10.5507836 9.59993995,13.2003764 L9.59993995,37.4432423 L34.1863096,55.2001137 C35.227514,55.9545035 37.1161253,56.5669508 38.4019571,56.5669508 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.7%",
    y: "-8.3%",
    width: "117.4%",
    height: "120.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F5F6",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tiered",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d-Tiered----Received-Payment",
    transform: "translate(-592.000000, -308.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logistics/payment",
    transform: "translate(602.000000, 312.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3996097,42.1081574 L76.7995196,31.7057811 L76.7995196,30.1082325 C76.7995196,27.8973576 75.782485,25.8077711 74.0410896,24.4428382 C72.71351,23.4017803 71.4550706,22.4223919 69.5995647,21.0212776 L50.7672118,7.20041675 C50.3112088,6.87038952 49.8866997,6.5614559 49.4112144,6.21648736 C46.8896481,4.37738753 41.8797674,-0.0519792963 38.3997598,0.000461781943 C34.9197523,-0.0519792963 29.9113364,4.3759227 27.3883053,6.21648736 C26.9128199,6.5614559 26.4883109,6.87038952 26.0323079,7.20041675 L7.19995497,21.0212776 C5.34444899,22.4207805 4.0860096,23.4017803 2.75843001,24.4428382 C1.23602743,25.635946 0,28.1740649 0,30.1082325 L0,31.7057811 L14.3999099,42.1081574 L62.3996097,42.1081574 Z",
    id: "Path",
    fill: "#23419E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6497614,43.3081527 L75.5997074,32.9057764 L75.5997074,31.3082278 C75.5997074,29.097353 74.6144527,27.0077664 72.9274719,25.6428336 C71.6413762,24.6017756 70.4222601,23.6223872 68.6247344,22.2212729 L50.380849,8.4004121 C49.939095,8.07038487 49.5278509,7.76145126 49.0672234,7.41648271 C46.6244503,5.57738289 41.7711167,1.14801606 38.3998514,1.20045714 C35.028586,1.14801606 30.1766715,5.57591805 27.7324793,7.41648271 C27.2718518,7.76145126 26.8606077,8.07038487 26.4188537,8.4004121 L8.17496836,22.2212729 C6.37744266,23.6207759 5.15832659,24.6017756 3.8722308,25.6428336 C2.39739978,26.8359413 1.19999536,29.3740602 1.19999536,31.3082278 L1.19999536,32.9057764 L15.1499414,43.3081527 L61.6497614,43.3081527 Z",
    id: "Path",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5995647,72 C73.5760046,72 76.7995196,68.776485 76.7995196,64.800045 L76.7995196,32.8292977 L45.4287686,55.4911677 C43.3257056,57.0090293 40.8627327,57.7695714 38.3997598,57.7695714 C35.9367869,57.7695714 33.4738141,57.0106406 31.370751,55.4911677 L0,32.8292977 L0,64.800045 C0,68.776485 3.22351499,72 7.19995497,72 L69.5995647,72 Z",
    id: "Path",
    fill: "#23419E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5995647,70.8000046 C73.5760046,70.8000046 76.7995196,67.5764897 76.7995196,63.6000497 L76.7995196,31.6293024 L45.4287686,54.2911724 C43.3257056,55.809034 40.8627327,56.5695761 38.3997598,56.5695761 C35.9367869,56.5695761 33.4738141,55.8106453 31.370751,54.2911724 L-4.26323991e-15,31.6293024 L-4.26323991e-15,63.6000497 C-4.26323991e-15,67.5764897 3.22351499,70.8000046 7.19995497,70.8000046 L69.5995647,70.8000046 Z",
    id: "Path",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.4019571,57.7669462 C39.6877889,57.7669462 41.5765466,57.1544988 42.617751,56.400109 L67.1995797,38.6432377 L67.1995797,14.4003717 C67.1995797,11.7507789 65.0492025,9.60040174 62.3996097,9.60040174 L14.3999099,9.60040174 C11.7503171,9.60040174 9.59993995,11.7507789 9.59993995,14.4003717 L9.59993995,38.6432377 L34.1863096,56.400109 C35.227514,57.1544988 37.1161253,57.7669462 38.4019571,57.7669462 Z",
    id: "Path",
    fill: "url(#linearGradient-6)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5997523,49.0501579 L37.1997673,49.0501579 C36.5373691,49.0501579 35.9997748,48.5125636 35.9997748,47.8501654 L35.9997748,45.4066748 C33.0252817,45.2566757 31.1473638,43.5797331 31.1668461,43.5797331 C30.9866714,43.3884257 30.8403344,43.0197268 30.8403344,42.7569355 C30.8403344,42.4708533 31.0093764,42.079303 31.2178223,41.8831617 L32.9803113,40.2002132 C33.1749878,40.0232612 33.5466163,39.8795609 33.8097006,39.8795609 C34.0180001,39.8795609 34.3272267,39.9741892 34.4997842,40.0906436 C34.9840585,40.397087 35.8421586,40.6478667 36.4152019,40.6502104 L40.6317283,40.6502104 C41.6067222,40.6502104 42.4016879,39.7622277 42.4016879,38.6716583 C42.4016879,37.7792811 41.8602851,36.9947157 41.0862665,36.7622464 L34.3363087,34.7372591 C31.5493144,33.9002526 29.5993266,31.2288338 29.5993266,28.2288525 C29.5993266,24.5507994 32.4567794,21.5628298 35.9997748,21.4683479 L35.9997748,19.0503455 C35.9997748,18.3879473 36.5373691,17.850353 37.1997673,17.850353 L39.5997523,17.850353 C40.2621505,17.850353 40.7997448,18.3879473 40.7997448,19.0503455 L40.7997448,21.4938361 C42.3012003,21.5596071 44.4697414,22.3781567 45.6401442,23.3207778 C45.9552301,23.655346 46.2011759,24.4443059 45.589168,25.0173492 L43.826679,26.7002976 C43.6324419,26.8779821 43.2609599,27.0221218 42.9977291,27.0221218 C42.7891367,27.0221218 42.4797636,26.927054 42.3072061,26.8098673 C41.820881,26.5026915 40.9594118,26.2520583 40.3843177,26.2503005 L36.1677914,26.2503005 C35.1927975,26.2503005 34.3978317,27.1382832 34.3978317,28.2288525 C34.3978317,29.1212298 34.9392346,29.9057952 35.7132532,30.1382644 L42.463211,32.1632518 C45.2502053,33.0002582 47.2001931,35.6716771 47.2001931,38.6716583 C47.2001931,42.3511763 44.3427402,45.3376811 40.7997448,45.4321629 L40.7997448,47.8501654 C40.7997448,48.5125636 40.2621505,49.0501579 39.5997523,49.0501579 Z",
    id: "Path",
    fill: "#7CB342",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5997523,47.8501625 L37.1997673,47.8501625 C36.5373691,47.8501625 35.9997748,47.3125682 35.9997748,46.65017 L35.9997748,44.2066794 C33.0252817,44.0566804 31.1473638,42.3797377 31.1668461,42.3797377 C30.9866714,42.1884303 30.8403344,41.8197315 30.8403344,41.5569401 C30.8403344,41.2708579 31.0093764,40.8793077 31.2178223,40.6831663 L32.9803113,39.0002178 C33.1749878,38.8232658 33.5466163,38.6795656 33.8097006,38.6795656 C34.0180001,38.6795656 34.3272267,38.7741939 34.4997842,38.8906482 C34.9840585,39.1970916 35.8421586,39.4478713 36.4152019,39.450215 L40.6317283,39.450215 C41.6067222,39.450215 42.4016879,38.5622323 42.4016879,37.471663 C42.4016879,36.5792857 41.8602851,35.7947203 41.0862665,35.5622511 L34.3363087,33.5372637 C31.5493144,32.7002573 29.5993266,30.0288384 29.5993266,27.0288572 C29.5993266,23.350804 32.4567794,20.3628344 35.9997748,20.2683526 L35.9997748,17.8503501 C35.9997748,17.1879519 36.5373691,16.6503576 37.1997673,16.6503576 L39.5997523,16.6503576 C40.2621505,16.6503576 40.7997448,17.1879519 40.7997448,17.8503501 L40.7997448,20.2938407 C42.3012003,20.3596118 44.4697414,21.1781614 45.6401442,22.1207824 C45.9552301,22.4553506 46.2011759,23.2443105 45.589168,23.8173538 L43.826679,25.5003023 C43.6324419,25.6779867 43.2609599,25.8221264 42.9977291,25.8221264 C42.7891367,25.8221264 42.4797636,25.7270587 42.3072061,25.6098719 C41.820881,25.3026961 40.9594118,25.0520629 40.3843177,25.0503051 L36.1677914,25.0503051 C35.1927975,25.0503051 34.3978317,25.9382878 34.3978317,27.0288572 C34.3978317,27.9212344 34.9392346,28.7057998 35.7132532,28.9382691 L42.463211,30.9632564 C45.2502053,31.8002629 47.2001931,34.4716817 47.2001931,37.471663 C47.2001931,41.151181 44.3427402,44.1376857 40.7997448,44.2321675 L40.7997448,46.65017 C40.7997448,47.3125682 40.2621505,47.8501625 39.5997523,47.8501625 Z",
    id: "Path",
    fill: "#8BC34A",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentReceived);
export default __webpack_public_path__ + "static/media/Payment-Received.97899a2599f3743cf5d30c5dc41ff751.svg";
export { ForwardRef as ReactComponent };